import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isCategoriesOpen, setIsCategoriesOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2 group cursor-pointer"
          >
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-file-list-3-line text-lg text-background-50"></i>
            </div>
            <span className="font-heading text-lg md:text-xl font-semibold text-foreground-900 whitespace-nowrap">
              SugargooSheet
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1"
            >
              <i className="ri-home-line text-sm"></i>
              Home
            </Link>
            <Link
              to="/article/sugargoo-spreadsheet-guide"
              className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1"
            >
              <i className="ri-book-open-line text-sm"></i>
              Shopping Guide
            </Link>
            <a
              href="#categories"
              className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              Categories
            </a>
            <a
              href="#articles"
              className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              Articles
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-sm px-5 py-2 bg-primary-500 text-background-50 rounded-full font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Explore Spreadsheet
            </a>
          </div>

          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 text-foreground-700 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-3 px-2 flex flex-col gap-1 max-h-[70vh] overflow-y-auto">
            <Link
              to="/"
              onClick={() => setIsMobileOpen(false)}
              className="flex items-center gap-2 text-sm text-foreground-700 hover:text-primary-500 transition-colors py-2.5 px-3 rounded-lg hover:bg-background-100 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-line"></i>
              Home
            </Link>
            <Link
              to="/article/sugargoo-spreadsheet-guide"
              onClick={() => setIsMobileOpen(false)}
              className="flex items-center gap-2 text-sm text-foreground-700 hover:text-primary-500 transition-colors py-2.5 px-3 rounded-lg hover:bg-background-100 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-book-open-line"></i>
              Shopping Guide
            </Link>
            <a
              href="#articles"
              onClick={() => setIsMobileOpen(false)}
              className="flex items-center gap-2 text-sm text-foreground-700 hover:text-primary-500 transition-colors py-2.5 px-3 rounded-lg hover:bg-background-100 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-article-line"></i>
              SEO Articles
            </a>

            <div className="border-t border-background-200/60 my-2 pt-2">
              <button
                onClick={() => setIsCategoriesOpen(!isCategoriesOpen)}
                className="flex items-center justify-between w-full text-sm font-semibold text-foreground-800 py-2.5 px-3 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
              >
                <span className="flex items-center gap-2">
                  <i className="ri-grid-line"></i>
                  Product Categories
                </span>
                <i className={`text-sm transition-transform ${isCategoriesOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
              </button>
              {isCategoriesOpen && (
                <div className="grid grid-cols-2 gap-1 mt-1 px-1">
                  {categories.map((cat) => (
                    <a
                      key={cat.id}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      onClick={() => setIsMobileOpen(false)}
                      className="flex items-center gap-2 text-xs text-foreground-600 hover:text-primary-500 hover:bg-background-100 transition-colors py-2 px-2.5 rounded-lg cursor-pointer truncate"
                    >
                      <i className={`${cat.icon} text-xs flex-shrink-0`}></i>
                      <span className="truncate">{cat.name}</span>
                    </a>
                  ))}
                </div>
              )}
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-center px-5 py-2.5 mt-2 bg-primary-500 text-background-50 rounded-full font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Explore Spreadsheet
              <i className="ri-arrow-right-up-line ml-1.5"></i>
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}